import React, { useCallback } from 'react';
import { observer } from 'mobx-react-lite';

import { useStore, useTranslation } from '../../../../../../../../hooks';
import { T } from '../../../../../../../../constants';

import './style.scss';

export const ReplayDialogPopup: React.FC = observer(() => {

  const t = useTranslation();
  const { gameStore, sidebarMenuStore } = useStore();
  const { replayDialogWin, isDemo, hasGameRedirection } = gameStore;

  const handleWatchReplay = useCallback(() => {
    if (!replayDialogWin?.hasReplay) return;
    gameStore.trackTopWinsReplay(replayDialogWin);
    gameStore.openReplay(replayDialogWin);
    sidebarMenuStore.setIsSidebarOpen(false);
  }, [replayDialogWin]);

  if (!replayDialogWin) return null;

  const handleClose = () => gameStore.setReplayDialogWin(null);

  const handlePlayNow = () => gameStore.playReplayGame(replayDialogWin);

  const playText = t(isDemo ? T.PLAY_DEMO : T.PLAY_NOW);

  return (
    <div className="min-popup-wrapper">
      <div className="min-popup">
        <button type="button" className="min-popup-close-button" onClick={handleClose}>
          <i className="icon-close min-popup-close-icon" />
        </button>
        <div className="min-popup-body">
          <p className="min-popup-body-title">
            <span className="min-popup-body-title-ready">
              {t(T.READY_TO_PLAY)}
            </span>
            <p className="min-popup-body-title-wrp">
              <span className="min-popup-body-title-name">{replayDialogWin.gameName}</span>
            </p>
          </p>
        </div>
        <div className="min-popup-footer">
          {replayDialogWin.hasReplay && (
            <button type='button' className="min-popup-button again-button" onClick={handleWatchReplay}>
              <i className="icon-replay-cards min-popup-button-icon" />
              <span className="min-popup-button-name">{t(T.WATCH_REPLAY)}</span>
            </button>
          )}
          {/* the play button launches the winner's game, so it only exists where the partner supports game redirection */}
          {hasGameRedirection && (
            <button type='button' className="min-popup-button play-button" onClick={handlePlayNow}>
              <i className="icon-play min-popup-button-icon-play" />
              <span className="min-popup-button-name">{playText}</span>
            </button>
          )}
        </div>
      </div>
    </div>
  );
});
